import { Injectable, Component } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router"; 

import { AppLoadService } from "digital-core";

@Injectable()
export class MainsalesResourcesResolver  {

  constructor(private resourcesLoader: AppLoadService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
     if(window['config'].core.siteUrl == null){
      window['config'].core.siteUrl = window['config'].site.apiUrl + "api/v1/";
     }
     let salesResources = this.resourcesLoader.loadSiteResources(); 
     return salesResources; 
  }
}
